import { useState } from "react";
import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function LogoutConfirmPopup({ cancelLogout }: { cancelLogout: () => void }) {
    const [loading, setLoading] = useState(false);
    const navigation = useNavigate();

    const handleLogout = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            sessionStorage.removeItem("jsonwebtoken");
            sessionStorage.removeItem("subscription_dialog_shown");
            navigation("/");
            // Put your real logout logic here (clear tokens, redirect, etc.)
        }, 2000);
    };

    return (
        <div >
            <div className="flex flex-col items-center text-center gap-3">
                <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center">
                    <LogOut size={22} className="text-red-500" />
                </div>

                <h2 className="text-lg font-semibold text-slate-800">
                    Leaving already?
                </h2>
                <p className="text-sm text-slate-500">
                    You'll be signed out of this session on this device.<br />You can log
                    back in anytime.
                </p>
            </div>

            <div className="mt-6 space-y-3">
                <button
                    onClick={handleLogout}
                    disabled={loading}
                    className="relative w-full py-2.5 rounded-lg bg-red-400 text-white text-sm font-medium overflow-hidden disabled:opacity-100 flex items-center justify-center gap-2"
                >
                    <span
                        className="absolute inset-y-0 left-0 bg-red-900 ease-linear"
                        style={{
                            width: loading ? "100%" : "0%",
                            transition: loading ? "width 2000ms linear" : "none",
                        }}
                    />
                    <span className="relative z-10 flex items-center justify-center gap-2">
                        {loading ? (
                            <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />
                        ) : (
                            <LogOut size={16} />
                        )}
                        {loading ? "Logging out..." : "Logout"}
                    </span>
                </button>

                <button
                    onClick={() => cancelLogout()}
                    disabled={loading}
                    className="w-full py-2.5 rounded-lg border border-slate-200 text-slate-700 text-sm font-medium hover:bg-slate-50 transition disabled:opacity-40"
                >
                    Cancel
                </button>
            </div>
        </div>
    );
}